<mat-sidenav-container class="sidenav">
    <mat-sidenav #sidenav [mode]="mode" [autoFocus]="false">
        <mat-nav-list>
            @if(menuItemsObs$ | async; as menuItemsToDisplay) {
                @for (item of menuItemsToDisplay; track item; let i = $index) {
                    @if (item.routerLink?.includes('http') && (item.workplaceCategory | findInArray : workplaceConfigNames) && (item.roles | authentication)) {
                        <a mat-list-item
                            [href]="getParamsUrl(item.routerLink, item.queryParams)"
                            (click)="menuItemClicked.emit(item)">
                            <mat-icon>{{ item.icon }}</mat-icon>
                            <span>{{ item.label | translate }}</span>
                        </a>
                    }

                    @if (!item.routerLink?.includes('http')) {
                        @if (item.subItems == null && (item.workplaceCategory | findInArray : workplaceConfigNames) && (item.roles | authentication)) {
                            <a mat-list-item
                                [routerLink]="item.routerLink" 
                                [routerLinkActive]="'active-link'"
                                [routerLinkActiveOptions]="{exact: false}"
                                [queryParams]="item.queryParams"
                                [skipLocationChange]="item.skipLocationChange"
                                [replaceUrl]="item.replaceUrl"
                                [queryParamsHandling]="item.queryParamsHandling"
                                [preserveFragment]="item.preserveFragment"
                                (click)="toggleMenuItem(i, true); menuItemClicked.emit(item)">
                                <mat-icon>{{ item.icon }}</mat-icon>
                                <span>{{ item.label | translate }}</span>
                            </a>
                            
                        }
    
                        @if (item.subItems != null) {
                            <div [class.opened]="activeLink == i" routerLinkActive="active-link-parent" [routerLinkActiveOptions]="{ exact: true }">
                                @if ((item.workplaceCategory | findInArray : workplaceConfigNames) && (item.roles | authentication)) {
                                    <a mat-list-item class="parent-menu-item" (click)="toggleMenuItem(i, false); menuItemClicked.emit(item)">
                                        <mat-icon>{{ item.icon }}</mat-icon>
                                        <span>{{ item.label  | translate }}</span>
                                        <mat-icon class="sub-items-toggle" [@subItemOpenClose]="activeLink == i ? 'open' : 'close'">
                                            keyboard_arrow_down
                                        </mat-icon>
                                    </a>
                                }
    
                                <mat-nav-list class="sub-item-list"
                                              [@subItem]="activeLink == i ? 'visibleAnimated' : 'hiddenAnimated'">
                                    @for (subItem of item.subItems; track $index) {
                                        @if (subItem.routerLink?.includes('http') && (subItem.workplaceCategory | findInArray : workplaceConfigNames) && (subItem.roles | authentication)) {
                                            <a mat-list-item
                                                class="sub-item"
                                                [href]="getParamsUrl(subItem.routerLink, subItem.queryParams)"
                                                (click)="close(); menuItemClicked.emit(subItem)">
                                                <mat-icon>{{ subItem.icon }}</mat-icon>
                                                <span>{{ subItem.label | translate }}</span>
                                            </a>
                                        }
    
                                        @if (!subItem.routerLink?.includes('http') && (subItem.workplaceCategory | findInArray : workplaceConfigNames) && (subItem.roles | authentication)) {
                                            <a mat-list-item
                                                class="sub-item"
                                                [routerLink]="subItem.routerLink" routerLinkActive="active-sub-link"
                                                [queryParams]="subItem.queryParams" [skipLocationChange]="item.skipLocationChange"
                                                [replaceUrl]="item.replaceUrl"
                                                [queryParamsHandling]="item.queryParamsHandling"
                                                [preserveFragment]="item.preserveFragment"
                                                (click)="close(); menuItemClicked.emit(subItem)">
                                                <mat-icon>{{ subItem.icon }}</mat-icon>
                                                <span>{{ subItem.label | translate }}</span>
                                            </a>
                                        }
                                    }
                                </mat-nav-list>
                            </div>
                        }
                    }
                }
            }

            @if (showThemeMode) {
                <div class="footer">
                    <mat-slide-toggle [(ngModel)]="isDarkMode" (change)="storeThemeSelection()" labelPosition="before">
                        {{'sla-ui-material.dark-mode.label' | translate}}
                    </mat-slide-toggle>
                </div>
            }
        </mat-nav-list>
        <ng-content select="[menuContent]"></ng-content>
    </mat-sidenav>

    <mat-sidenav-content [class.with-topbar]="loggedIn">
        <ng-content></ng-content>
    </mat-sidenav-content>
</mat-sidenav-container>
